// extracted by mini-css-extract-plugin
export default {"main":"_80aa01ba5e","tit":"_39961a836c","maintitle":"d998f9ba19","ylw":"d779d85872","white":"_443638900e","mv_title":"fbd0ece1eb","mv_nc":"_0b992a635f","mv_in":"_28747ec46c"};